import React, {useState} from "react";
import {
    DetailKvListValue,
    KV_LIST_TYPES,
    DetailKvReadOnly,
    DetailKvTable,
    DetailPanel,
} from "../../../../../../components/detailLayout";
import {comment} from "../../../../../../api/asset/DiligenceService";
import Th_title from "../../../../../../components/Th_title";
import SimmsTextArea from "../../../../../../components/input/SimmsTextArea";
import {inputOnChange, inputOnKeyDown} from "../../../../../../components/commonmethod/simmsInputMethod";

function formatShortDate(value) {
    if (!value) return "";
    const datePart = String(value).substring(0, 10);
    if (datePart.length < 10) return datePart;
    return datePart.slice(2);
}

function DiligenceProgress({done, total}) {
    const safeTotal = Number(total) || 0;
    const safeDone = Number(done) || 0;
    const percent = safeTotal === 0 ? 0 : Math.min((safeDone / safeTotal) * 100, 100);
    const percentLabel = percent >= 100 ? "100" : percent < 10 ? percent.toFixed(1) : String(Math.round(percent));

    return (
        <div className="flex min-w-0 flex-col gap-1.5 py-px">
            <div className="flex items-center justify-between gap-2">
                <span className="text-[13px] text-[#333]">
                    {safeDone}/{safeTotal} 완료
                </span>
                <span className="text-[12px] font-semibold tabular-nums text-[#2563eb]">
                    {percentLabel}%
                </span>
            </div>
            <div
                className="relative h-[7px] min-w-0 overflow-hidden rounded-full bg-[#e8eef5]"
                aria-hidden
            >
                <div
                    className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] transition-[width] duration-300 ease-out"
                    style={{width: `${percent}%`}}
                />
            </div>
        </div>
    );
}

function DiligenceReport({diligence, setDiligence, assets, handler}) {
    const [clicked, setClicked] = useState(false);

    const checkedCount = (diligence.assets ?? []).filter((e) => e.checked === true).length;
    const totalCount = (diligence.assets ?? []).length;

    return (
        <DetailPanel title="실사 보고서">
            <DetailKvTable>
                <tbody>
                <tr>
                    <DetailKvReadOnly label="등록일시" value={diligence?.createdAt} type="date" />
                    <DetailKvReadOnly label="수정일시" value={diligence?.updatedAt} type="date" />
                </tr>
                <tr>
                    <DetailKvReadOnly label="등록자" value={diligence?.createdBy?.name} />
                    <DetailKvReadOnly label="수정자" value={diligence?.updatedBy?.name} />
                </tr>
                <tr>
                    <th className="fieldset-th simms-detail-th truncate">실사 진행률</th>
                    <td colSpan={3} className="fieldset-td">
                        <DiligenceProgress done={checkedCount} total={totalCount} />
                    </td>
                </tr>
                <tr>
                    <DetailKvReadOnly label="실사명" value={diligence?.title} />
                    <DetailKvReadOnly label="실사번호" value={diligence?.tickets} />
                </tr>
                <tr>
                    <DetailKvReadOnly label="요청자" value={diligence?.requestedBy?.name} />
                    <th className="fieldset-th simms-detail-th truncate">요청일</th>
                    <td className="fieldset-td">
                        <span className="asset-detail-kv-value">
                            {formatShortDate(diligence?.reqStartDate)} ~ {formatShortDate(diligence?.reqEndDate)}
                        </span>
                    </td>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="담당자" colspan={1} className="fieldset-td relative align-top">
                        <DetailKvListValue items={handler} listType={KV_LIST_TYPES.user} />
                    </Th_title>
                    <Th_title title="자산목록" colspan={1} className="fieldset-td relative align-top">
                        <DetailKvListValue items={assets} listType={KV_LIST_TYPES.asset} />
                    </Th_title>
                </tr>
                <tr
                    className="asset-detail-kv-row--auto asset-detail-kv-row--remark"
                    style={{"--detail-kv-textarea-min-h": "100px", "--detail-kv-textarea-max-h": "160px"}}
                >
                    <Th_title title="실사의견" colspan={3} className="fieldset-td" auth={diligence.auth?.report}>
                        <SimmsTextArea
                            onChange={(v) => inputOnChange(setDiligence, "comment", v, true)}
                            setClicked={setClicked}
                            clicked={clicked}
                            auth={diligence.auth?.report}
                            update
                            style={{width: "100%", minHeight: "100px", maxHeight: "160px"}}
                            onKeyDown={(v, e) => inputOnKeyDown(setDiligence, comment, diligence.id, "comment", v, e, true)}
                            data={diligence.comment}
                        />
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );
}

export default React.memo(DiligenceReport);
